import { IRequest } from '@r1-frontend/shared/types/IRequest';

/**
 * Расчет базовой стоимости КП, моно интернета для тарифа-конструктор
 * @link https://master.api-tariffs.sandbox.d2c.r-one.io/docs#/Tariff/TariffController_constructorPrice
 */
const constructorPrice = (providerId?: number): IRequest => ({
    uri: 'v1/tariff/constructor-price',
    method: 'GET',
    // TODO разобраться почему не работает при решении задачи https://ticket.ertelecom.ru/browse/WEB-49789
    // withProvider: true,
    headers: {
        'ProviderId': `${providerId}`,
    },
});

export default constructorPrice;
